export interface Range<T> {
  start: T;
  end: T;
}
